<template>
  <div class="container">
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current='page'
      :disablePage="toDisablePage"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>查询表单:</label>
            <lk-select v-model='currentFormKey' class="item" clearable @on-change="handleFormChange">
              <lk-option v-for="item in formList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-card title="医疗目录信息查询">
          <div v-for="item in config">
            <div v-if="item.key === currentFormKey" style="">
              <div style="display:flex;margin-bottom:10px;flex-wrap:wrap;">
                <div v-for="subItem in item.conditions" style="margin-bottom:10px;">
                  <div v-if="subItem.type==='input'" class="flexCenter">
                    <div>{{subItem.title}}：</div>
                    <lk-input v-model="subItem.value" :clearable="true" :maxlength="subItem.maxlength" style="width:200px;" :placeholder="subItem.placeholder"></lk-input>
                  </div>
                  <div v-if="subItem.type==='date'" class="flexCenter">
                    <div>{{subItem.title}}：</div>
                    <timeStampDatePicker type='date' class="item" v-model="subItem.value" :clearable="true" :placeholder="subItem.placeholder"></timeStampDatePicker>
                  </div>
                  <div v-if="subItem.type==='select'" class="flexCenter">
                    <div>{{subItem.title}}：</div>
                    <lk-select v-model="subItem.value" :placeholder="subItem.placeholder" style="width:200px;">
                      <lk-option v-for="option in subItem.options" :value="option.id" :key="option.id">{{option.name}}</lk-option>
                    </lk-select>
                  </div>
                </div>
                <div v-if="item.conditions.length>0">
                  <lk-button @click="handleSearch" type="primary" style="margin:0 20px;">查询</lk-button>
                  <lk-button @click="handleReset">重置</lk-button>
                </div>
              </div>
              <lk-table border :columns="item.columns" :data="tableData"></lk-table>
            </div>
          </div>
        </lk-card>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import utils from '../../libs/utils';
import healthInsManage from '../../services/healthInsManage.js';

export default {
  name: 'insInfoSearch',
  mixins: [queryMixins, mapState],
  components: {
    QueryFrame,
  },
  computed: {
    toDisablePage() {
      if ([5206, 5201, 5202, 5102].includes(this.currentFormKey)) {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    return {
      formList: [
        {
          id: 1304,
          name: '民族药品目录查询'
        },
        {
          id: 1312,
          name: '医保目录信息查询'
        },
        {
          id: 1318,
          name: '医保目录限价信息查询'
        },
        {
          id: 1319,
          name: '医保目录先自付比例信息查询'
        },
        {
          id: 5102,
          name: '医执人员信息查询'
        },
        {
          id: 5201,
          name: '就诊信息查询'
        },
        {
          id: 5202,
          name: '诊断信息查询'
        },
        {
          id: 5206,
          name: '人员累计信息查询'
        },
        {
          id: 1316,
          name: '医疗目录与医保目录匹配信息查询'
        },
        {
          id: 1317,
          name: '医药机构目录匹配信息查询'
        },
      ],
      tableData: [],
      count: 0,
      query: {},
      currentFormKey: 1304,
      config: [
        {
          key: 1304,
          name: '民族药品目录查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'fixmedinsHilistId',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/nationalDrugCatalogInfo',
          columns: [
            {
              title: '医疗目录编码',
              key: 'medListCodg',
              minWidth: 116
            },
            {
              title: '药品商品名',
              key: 'drugProdname',
              minWidth: 116
            },
            {
              title: '通用名编号',
              key: 'gennameCodg',
              minWidth: 116
            },
            {
              title: '药品通用名',
              key: 'drugGenname',
              minWidth: 116
            },
            {
              title: '民族药种类',
              key: 'ethdrugType',
              minWidth: 116
            },
            {
              title: '化学名称',
              key: 'chemname',
              minWidth: 116
            },
            {
              title: '别名',
              key: 'alis',
              minWidth: 116
            },
            {
              title: '英文名称',
              key: 'engName',
              minWidth: 116
            },
            {
              title: '剂型',
              key: 'dosform',
              minWidth: 116
            },
            {
              title: '每次用量',
              key: 'eachDos',
              minWidth: 116
            },
            {
              title: '使用频次',
              key: 'usedFrqu',
              minWidth: 116
            },
            {
              title: '国家药品编号',
              key: 'natDrugNo',
              minWidth: 116
            },
            {
              title: '用法',
              key: 'usedMtd',
              minWidth: 116
            },
            {
              title: '成分',
              key: 'ing',
              minWidth: 116
            },
            {
              title: '性状',
              key: 'chrt',
              minWidth: 116
            },
            {
              title: '不良反应',
              key: 'defs',
              minWidth: 116
            },
            {
              title: '禁忌',
              key: 'tabo',
              minWidth: 116
            },
            {
              title: '注意事项',
              key: 'mnan',
              minWidth: 116
            },
            {
              title: '贮藏',
              key: 'stog',
              minWidth: 116
            },
            {
              title: '药品规格',
              key: 'drugSpec',
              minWidth: 116
            },
            {
              title: '计价单位类型',
              key: 'prcuntType',
              minWidth: 116
            },
            {
              title: '非处方药标志',
              key: 'otcFlag',
              minWidth: 116
            },
            {
              title: '包装材质',
              key: 'pacmatl',
              minWidth: 116
            },
            {
              title: '包装规格',
              key: 'pacspec',
              minWidth: 116
            },
            {
              title: '最小使用单位',
              key: 'minUseunt',
              minWidth: 116
            },
            {
              title: '最小销售单位',
              key: 'minSalunt',
              minWidth: 116
            },
            {
              title: '说明书',
              key: 'manl',
              minWidth: 116
            },
            {
              title: '给药途径',
              key: 'rute',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '药理分类',
              key: 'phamType',
              minWidth: 116
            },
            {
              title: '备注',
              key: 'memo',
              minWidth: 116
            },
            {
              title: '包装数量',
              key: 'pacCnt',
              minWidth: 116
            },
            {
              title: '最小计量单位',
              key: 'minUnt',
              minWidth: 116
            },
            {
              title: '最小包装数量',
              key: 'minPacCnt',
              minWidth: 116
            }, //
            {
              title: '最小包装单位',
              key: 'minPacunt',
              minWidth: 116
            },
            {
              title: '最小制剂单位',
              key: 'minPrepunt',
              minWidth: 116
            },
            {
              title: '药品有效期',
              key: 'drugExpy',
              minWidth: 116
            },
            {
              title: '功能主治',
              key: 'efccAtd',
              minWidth: 116
            },
            {
              title: '最小计价单位',
              key: 'minPrcunt',
              minWidth: 116
            },
            {
              title: '五笔助记码',
              key: 'wubi',
              minWidth: 116
            },
            {
              title: '拼音助记码',
              key: 'pinyin',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '数据创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '数据更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建经办机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '版本号',
              key: 'ver',
              minWidth: 116
            },
          ],
        },
        {
          key: 1312,
          name: '医保目录信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'fixmedinsHilistId',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/medDireInfo',
          columns: [
            {
              title: '医保目录编码',
              key: 'hilistCode',
              minWidth: 116
            },
            {
              title: '医保目录名称',
              key: 'hilistName',
              minWidth: 116
            },
            {
              title: '参保机构医保区划',
              key: 'insuAdmdvs',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '医疗收费项目类别',
              key: 'medChrgitmType',
              minWidth: 116
            },
            {
              title: '收费项目等级',
              key: 'chrgitmLv',
              minWidth: 116
            },
            {
              title: '限制使用标志',
              key: 'lmtUsedFlag',
              minWidth: 116
            },
            {
              title: '目录类别',
              key: 'listType',
              minWidth: 116
            },
            {
              title: '医疗使用标志',
              key: 'medUseFlag',
              minWidth: 116
            },
            {
              title: '生育使用标志',
              key: 'matnUsedFlag',
              minWidth: 116
            },
            {
              title: '医保目录使用类别',
              key: 'hilistUseType',
              minWidth: 116
            },
            {
              title: '限复方使用类型',
              key: 'lmtCpndType',
              minWidth: 116
            },
            {
              title: '五笔助记码',
              key: 'wubi',
              minWidth: 116
            },
            {
              title: '拼音助记码',
              key: 'pinyin',
              minWidth: 116
            },
            {
              title: '备注',
              key: 'memo',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '创建机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '统筹区',
              key: 'poolareaNo',
              minWidth: 116
            },
          ],
        },
        {
          key: 1318,
          name: '医保目录限价信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'fixmedinsHilistId',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/medDirePriceInfo',
          columns: [
            {
              title: '医保目录编码',
              key: 'hilistCode',
              minWidth: 116
            },
            {
              title: '医保目录限价类型',
              key: 'hilistLmtpricType',
              minWidth: 116
            },
            {
              title: '医保目录超限处理方式',
              key: 'overlmtDspoWay',
              minWidth: 116
            },
            {
              title: '参保机构医保区划',
              key: 'insuAdmdvs',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '医保目录定价上限金额',
              key: 'hilistPricUplmtAmt',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '创建机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '表名',
              key: 'tabname',
              minWidth: 116
            },
            {
              title: '统筹区',
              key: 'poolareaNo',
              minWidth: 116
            },
          ],
        },
        {
          key: 1319,
          name: '医保目录先自付比例信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'fixmedinsHilistId',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/medDireRateInfo',
          columns: [
            {
              title: '医保目录编码',
              key: 'hilistCode',
              minWidth: 116
            },
            {
              title: '医保目录自付比例人员类别',
              key: 'selfpayPropPsnType',
              minWidth: 116
            },
            {
              title: '目录自付比例类别',
              key: 'selfpayPropType',
              minWidth: 116
            },
            {
              title: '参保机构医保区划',
              key: 'insuAdmdvs',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '自付比例',
              key: 'selfpayProp',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '创建机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '表名',
              key: 'tabname',
              minWidth: 116
            },
            {
              title: '统筹区',
              key: 'poolareaNo',
              minWidth: 116
            },
          ],
        },
        {
          key: 5102,
          name: '医执人员信息查询',
          conditions: [
            {
              type: 'select',
              value: '',
              title: '执业人员',
              key: 'pracPsnType',
              options: [
                {
                  id: 1,
                  name: '医师'
                },
                {
                  id: 2,
                  name: '护士'
                },
                {
                  id: 3,
                  name: '药师'
                },
                {
                  id: 4,
                  name: '医技人员'
                },
              ]
            }
          ],
          interface: '/medical/medicalPersonInfo',
          columns: [
            {
              title: '人员证件类型',
              key: 'psnCertType',
              minWidth: 116
            },
            {
              title: '证件号码',
              key: 'certno',
              minWidth: 116
            },
            {
              title: '执业人员自编号',
              key: 'pracPsnNo',
              minWidth: 116
            },
            {
              title: '执业人员代码',
              key: 'pracPsnCode',
              minWidth: 116
            },
            {
              title: '执业人员姓名',
              key: 'pracPsnName',
              minWidth: 116
            },
            {
              title: '执业人员分类',
              key: 'pracPsnType',
              minWidth: 116
            },
            {
              title: '执业人员资格证书编码',
              key: 'pracPsnCert',
              minWidth: 116
            },
            {
              title: '执业证书编号',
              key: 'pracCertNo',
              minWidth: 116
            },
            {
              title: '医保医师标志',
              key: 'hiDrFlag',
              minWidth: 116
            },
            {
              title: '开始时间',
              key: 'begntime',
              minWidth: 116
            },
            {
              title: '结束时间',
              key: 'endtime',
              minWidth: 116
            },
            {
              title: '变更原因',
              key: 'chgRea',
              minWidth: 116
            },
          ],
        },
        {
          key: 5201,
          name: '就诊信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: '人员编号',
              key: 'psnNo',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '开始时间',
              key: 'begntime',
              value: '',
              placeholder: '请选择时间'
            },
            {
              id: 3,
              type: 'date',
              title: '结束时间',
              key: 'endtime',
              value: '',
              placeholder: '请选择时间'
            },
            {
              type: 'select',
              value: '',
              title: '医疗类别',
              key: 'medType',
              options: [
                {
                  id: 41,
                  name: '定点药店购药'
                },
                {
                  id: 11,
                  name: '普通门诊'
                },
              ]
            }
          ],
          interface: '/medical/mdtrtInfos',
          columns: [
            {
              title: '就诊 ID',
              key: 'mdtrtId',
              minWidth: 116
            },
            {
              title: '人员编号',
              key: 'psnNo',
              minWidth: 116
            },
            {
              title: '人员证件类型',
              key: 'psnCertType',
              minWidth: 116
            },
            {
              title: '证件号码',
              key: 'certno',
              minWidth: 116
            },
            {
              title: '人员姓名',
              key: 'psnName',
              minWidth: 116
            },
            {
              title: '性别',
              key: 'gend',
              minWidth: 116
            },
            {
              title: '民族',
              key: 'naty',
              minWidth: 116
            },
            {
              title: '出生日期',
              key: 'brdy',
              minWidth: 116
            },
            {
              title: '年龄',
              key: 'age',
              minWidth: 116
            },
            {
              title: '联系人姓名',
              key: 'conerName',
              minWidth: 116
            },
            {
              title: '联系电话',
              key: 'tel',
              minWidth: 116
            },
            {
              title: '险种类型',
              key: 'insutype',
              minWidth: 116
            },
            {
              title: '人员类别',
              key: 'psnType',
              minWidth: 116
            },
            {
              title: '医疗救助对象标志',
              key: 'mafPsnFlag',
              minWidth: 116
            },
            {
              title: '公务员标志',
              key: 'cvlservFlag',
              minWidth: 116
            },
            {
              title: '灵活就业标志',
              key: 'flxempeFlag',
              minWidth: 116
            },
            {
              title: '新生儿标志',
              key: 'nwbFlag',
              minWidth: 116
            },
            {
              title: '参保机构医保 区划',
              key: 'insuOptins',
              minWidth: 116
            },
            {
              title: '单位名称',
              key: 'empName',
              minWidth: 116
            },
            {
              title: '开始时间',
              key: 'begntime',
              minWidth: 116
            },
            {
              title: '结束时间',
              key: 'endtime',
              minWidth: 116
            },
            {
              title: '就诊凭证类型',
              key: 'mdtrtCertType',
              minWidth: 116
            },
            {
              title: '医疗类别',
              key: 'medType',
              minWidth: 116
            },
            {
              title: '跨年度住院标志',
              key: 'arsYearIptFlag',
              minWidth: 116
            },
            {
              title: '先行支付标志',
              key: 'prePayFlag',
              minWidth: 116
            },
            {
              title: '住院/门诊号',
              key: 'iptOtpNo',
              minWidth: 116
            },
            {
              title: '病历号',
              key: 'medrcdno',
              minWidth: 116
            },
            {
              title: '主治医生编码',
              key: 'atddrNo',
              minWidth: 116
            },
            {
              title: '主诊医师姓名',
              key: 'chfpdrName',
              minWidth: 116
            },
            {
              title: '入院科室编码',
              key: 'admDeptCodg',
              minWidth: 116
            },
            {
              title: '入院科室名称',
              key: 'admDeptName',
              minWidth: 116
            },
            {
              title: '入院床位',
              key: 'admBed',
              minWidth: 116
            },
            {
              title: '住院主诊断代码',
              key: 'dscgMaindiagCode',
              minWidth: 116
            },
            {
              title: '住院主诊断名 称',
              key: 'dscgMaindiagName',
              minWidth: 116
            },
            {
              title: '出院科室编码',
              key: 'dscgDeptCodg',
              minWidth: 116
            },
            {
              title: '出院科室名称',
              key: 'dscgDeptName',
              minWidth: 116
            },
            {
              title: '出院床位',
              key: 'dscgBed',
              minWidth: 116
            },
            {
              title: '离院方式',
              key: 'dscgWay',
              minWidth: 116
            },
            {
              title: '主要病情描述',
              key: 'mainCondDscr',
              minWidth: 116
            },
            {
              title: '病种编码',
              key: 'diseCodg',
              minWidth: 116
            },
            {
              title: '病种名称',
              key: 'diseName',
              minWidth: 116
            },
            {
              title: '手术操作代码',
              key: 'oprnOprtCode',
              minWidth: 116
            },
            {
              title: '手术操作名称',
              key: 'oprnOprtName',
              minWidth: 116
            },
            {
              title: '门诊诊断信息',
              key: 'otpDiagInfo',
              minWidth: 116
            },
            {
              title: '在院状态',
              key: 'inhospStas',
              minWidth: 116
            },
            {
              title: '死亡日期',
              key: 'dieDate',
              minWidth: 116
            },
            {
              title: '住院天数',
              key: 'iptDays',
              minWidth: 116
            },
            {
              title: '计划生育服务 证号',
              key: 'fpscNo',
              minWidth: 116
            },
            {
              title: '生育类别',
              key: 'matnType',
              minWidth: 116
            },
            {
              title: '计划生育手术 类别',
              key: 'birctrlType',
              minWidth: 116
            },
            {
              title: '晚育标志',
              key: 'latechbFlag',
              minWidth: 116
            },
            {
              title: '孕周数',
              key: 'gesoVal',
              minWidth: 116
            },
            {
              title: '胎次',
              key: 'fetts',
              minWidth: 116
            },
            {
              title: '胎儿数',
              key: 'fetusCnt',
              minWidth: 116
            },
            {
              title: '早产标志',
              key: 'pretFlag',
              minWidth: 116
            },
            {
              title: '计划生育手术或生育日期',
              key: 'birctrlMatnDate',
              minWidth: 116
            },
            {
              title: '伴有并发症标 志',
              key: 'copFlag',
              minWidth: 116
            },
            {
              title: '经办人 ID',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '备注',
              key: 'memo',
              minWidth: 116
            },
          ],
        },
        {
          key: 5202,
          name: '诊断信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: '人员编号',
              key: 'psnNo',
              value: '',
              maxlength: 50,
              placeholder: '请输入'
            },
            {
              id: 2,
              type: 'input',
              title: '结算ID',
              key: 'mdtrtId',
              value: '',
              maxlength: 50,
              placeholder: '请输入'
            },
          ],
          interface: '/medical/diagnosisInfos',
          columns: [
            {
              title: '诊断信息 ID',
              key: 'diagInfoId',
              minWidth: 116
            },
            {
              title: '就诊 ID',
              key: 'mdtrtId',
              minWidth: 116
            },
            {
              title: '人员编号',
              key: 'psnNo',
              minWidth: 116
            },
            {
              title: '出入院诊断类 别',
              key: 'inoutDiagType',
              minWidth: 116
            },
            {
              title: '诊断类别',
              key: 'diagType',
              minWidth: 116
            },
            {
              title: '主诊断标志',
              key: 'maindiagFlag',
              minWidth: 116
            },
            {
              title: '诊断排序号',
              key: 'diagSrtNo',
              minWidth: 116
            },
            {
              title: '诊断代码',
              key: 'diagCode',
              minWidth: 116
            },
            {
              title: '诊断名称',
              key: 'diagName',
              minWidth: 116
            },
            {
              title: '入院病情',
              key: 'admCond',
              minWidth: 116
            },
            {
              title: '诊断科室',
              key: 'diagDept',
              minWidth: 116
            },
            {
              title: '诊断医生编码',
              key: 'diseDorNo',
              minWidth: 116
            },
            {
              title: '诊断医生姓名',
              key: 'diseDorName',
              minWidth: 116
            },
            {
              title: '诊断时间',
              key: 'diagTime',
              minWidth: 116
            },
            {
              title: '经办人ID',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
          ],
        },
        {
          key: 5206,
          name: '人员累计信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: '人员编号',
              key: 'psnNo',
              value: '',
              maxlength: 50,
              placeholder: '请输入'
            },
          ],
          interface: '/medical/userCumulateInfos',
          columns: [
            {
              title: '险种类型',
              key: 'insutype',
              minWidth: 116
            },
            {
              title: '年度',
              key: 'year',
              minWidth: 116
            },
            {
              title: '累计年月',
              key: 'cumYm',
              minWidth: 116
            },
            {
              title: '累计类别代码',
              key: 'cumTypeCode',
              minWidth: 116
            },
            {
              title: '累计值',
              key: 'cum',
              minWidth: 116
            },
          ],
        },
        {
          key: 1316,
          name: '医疗目录与医保目录匹配信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'medinsListCodg',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/medMatchingDire',
          columns: [
            {
              title: '医疗目录编码',
              key: 'medListCodg',
              minWidth: 116
            },
            {
              title: '医保目录编码',
              key: 'hilistCode',
              minWidth: 116
            },
            {
              title: '目录类别',
              key: 'listType',
              minWidth: 116
            },
            {
              title: '参保机构医保区划',
              key: 'insuAdmdvs',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '备注',
              key: 'memo',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '创建机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '统筹区',
              key: 'poolareaNo',
              minWidth: 116
            },
          ],
        },
        {
          key: 1317,
          name: '医药机构目录匹配信息查询',
          conditions: [
            {
              id: 1,
              type: 'input',
              title: 'erp药品编码',
              key: 'fixmedinsCode',
              value: '',
              maxlength: 50,
              placeholder: '请输入药品编码'
            },
            {
              id: 2,
              type: 'date',
              title: '更新时间',
              key: 'updtTime',
              value: '',
              placeholder: '请选择时间'
            }
          ],
          interface: '/medical/getInstitutionDire',
          columns: [
            {
              title: '定点医药机构编号',
              key: 'fixmedinsCode',
              minWidth: 116
            },
            {
              title: '定点医药机构目录编号',
              key: 'medinsListCodg',
              minWidth: 116
            },
            {
              title: '定点医药机构目录名称',
              key: 'medinsListName',
              minWidth: 116
            },
            {
              title: '参保机构医保区划',
              key: 'insuAdmdvs',
              minWidth: 116
            },
            {
              title: '目录类别',
              key: 'listType',
              minWidth: 116
            },
            {
              title: '医疗目录编码',
              key: 'medListCodg',
              minWidth: 116
            },
            {
              title: '开始日期',
              key: 'begndate',
              minWidth: 116
            },
            {
              title: '结束日期',
              key: 'enddate',
              minWidth: 116
            },
            {
              title: '批准文号',
              key: 'aprvno',
              minWidth: 116
            },
            {
              title: '剂型',
              key: 'dosform',
              minWidth: 116
            },
            {
              title: '除外内容',
              key: 'exctCont',
              minWidth: 116
            },
            {
              title: '项目内涵',
              key: 'itemCont',
              minWidth: 116
            },
            {
              title: '计价单位',
              key: 'prcunt',
              minWidth: 116
            },
            {
              title: '规格',
              key: 'spec',
              minWidth: 116
            },
            {
              title: '包装规格',
              key: 'pacspec',
              minWidth: 116
            },
            {
              title: '备注',
              key: 'memo',
              minWidth: 116
            },
            {
              title: '有效标志',
              key: 'valiFlag',
              minWidth: 116
            },
            {
              title: '唯一记录号',
              key: 'rid',
              minWidth: 116
            },
            {
              title: '更新时间',
              key: 'updtTime',
              minWidth: 116
            },
            {
              title: '创建人',
              key: 'crterId',
              minWidth: 116
            },
            {
              title: '创建人姓名',
              key: 'crterName',
              minWidth: 116
            },
            {
              title: '创建时间',
              key: 'crteTime',
              minWidth: 116
            },
            {
              title: '创建机构',
              key: 'crteOptinsNo',
              minWidth: 116
            },
            {
              title: '经办人',
              key: 'opterId',
              minWidth: 116
            },
            {
              title: '经办人姓名',
              key: 'opterName',
              minWidth: 116
            },
            {
              title: '经办时间',
              key: 'optTime',
              minWidth: 116
            },
            {
              title: '经办机构',
              key: 'optinsNo',
              minWidth: 116
            },
            {
              title: '统筹区',
              key: 'poolareaNo',
              minWidth: 116
            },
          ],
        },
      ]
    }
  },
  methods: {
    handleReset() {
      let obj = this.findAconfig(this.currentFormKey, this.config);
      obj.conditions.forEach(item => {
        item.value = '';
      })
    },
    handleFormChange() {
      this.tableData = [];
      this.page = 1;
    },
    handleSearch() {
      this.query = {};
      let obj = this.findAconfig(this.currentFormKey, this.config);
      obj.conditions.forEach(item => {
        this.query[item.key] = item.value;
      })
      this.query.pageNum = this.page;
      this.query.pageSize = this.size;
      this.getData(obj.interface);
    },
    getData(path) {
      healthInsManage.commonSearch(this.query, path).then(res => {
        if (res.data.status === 200) {
          let resData = res.data.data;
          this.count = resData.count;
          this.dealWithDataByKey(this.currentFormKey, resData.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    findAconfig(key, config) { // 根据currentFormKey找到对应的配置项
      let obj = config.find(item => item.key === key);
      if (obj) { // 返回配置项
        return obj
      } else {
        return obj // 返回undefined
      }
    },
    transformData(config=[], data) {
      config.forEach(item => {
        data.forEach(dataItem => {
          switch (item.format) {
            case 'date':
              dataItem[item.key] = dataItem[item.key] ? utils.formatDate(dataItem[item.key]) : '';
              break;
            case 'second':
              dataItem[item.key] = dataItem[item.key] ? utils.formatDateToSecond(dataItem[item.key]) : '';
              break;
            case 'clear':
              dataItem[item.key] = typeof dataItem[item.key] === 'string' ? dataItem[item.key] : '';
          }
        })
      })
      return data
    },
    dealWithDataByKey(key, resData) { // 该函数根据外部表单类型和接口返回数据进行不同的字段处理，然后将处理好的数据传给tabledata展示
      switch (key) {
        case 1304:
          let config1 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config1, resData);
          break;
        case 1312:
          var config2 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
            {
              key: 'optTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config2, resData);
          break;
        case 1318:
          let config3 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config3, resData);
          break;
        case 1319:
          let config4 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
            {
              key: 'optTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config4, resData);
          break;
        case 5102:
          let config5 = [
            {
              key: 'begntime',
              format: 'date'
            },
            {
              key: 'endtime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config5, resData);
          break;
        case 5201:
          let config6 = [
            {
              key: 'begntime',
              format: 'second'
            },
            {
              key: 'endtime',
              format: 'date'
            },
            {
              key: 'brdy',
              format: 'date'
            },
            {
              key: 'dieDate',
              format: 'date'
            },
            {
              key: 'birctrlMatnDate',
              format: 'date'
            },
            {
              key: 'optTime',
              format: 'second'
            },
          ];
          this.tableData = this.transformData(config6, resData);
          break;
        case 5202:
          let config7 = [
            {
              key: 'diagTime',
              format: 'second'
            },
            {
              key: 'optTime',
              format: 'second'
            },
          ];
          this.tableData = this.transformData(config7, resData);
          break;
        case 5206:
          this.tableData = this.transformData([
            {
              key: 'cumYm',
              format: 'clear'
            }
          ], resData);
          break;
        case 1316:
          let config8 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
            {
              key: 'optTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config8, resData);
          break;
        case 1317:
          let config9 = [
            {
              key: 'begndate',
              format: 'date'
            },
            {
              key: 'enddate',
              format: 'date'
            },
            {
              key: 'crteTime',
              format: 'date'
            },
            {
              key: 'updtTime',
              format: 'date'
            },
            {
              key: 'optTime',
              format: 'date'
            },
          ];
          this.tableData = this.transformData(config9, resData);
          break;
      }
    }
  },
}
</script>
<style lang="less" scoped>
.flexCenter {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
</style>